import type { SVGProps } from "react";

export const ChartBarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M7.5 12.75C7.91421 12.75 8.25 13.0858 8.25 13.5V18C8.25 18.4142 7.91421 18.75 7.5 18.75C7.08579 18.75 6.75 18.4142 6.75 18V13.5C6.75 13.0858 7.08579 12.75 7.5 12.75ZM12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V6C11.25 5.58579 11.5858 5.25 12 5.25ZM16.5 9.75C16.9142 9.75 17.25 10.0858 17.25 10.5V18C17.25 18.4142 16.9142 18.75 16.5 18.75C16.0858 18.75 15.75 18.4142 15.75 18V10.5C15.75 10.0858 16.0858 9.75 16.5 9.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
